export const MoreInfoItem = ({ description, onOpenModal, title }) => {
  return (
    <div className = 'bike_more-info' onClick = { onOpenModal } >
        <p className = 'title'>{ title }</p>
        <p className = 'description'>{ description }</p>
    </div>
  )
}
